﻿import { product_price } from "./product_price";

export class product_detail_seller_information_month {
    public year: number = 0;
    public month: number = 0;
    public currencies: product_price[] = [];
}